import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { ThyDialog, ThyNotifyService, ThyPopBoxService } from 'ngx-tethys';
import { isString } from './helpers';

const status = {
    ok: 200,
    notFound: 400,
    invalidInput: 401,
    forbidden: 403,
    internalError: 500
};

export interface ErrorHandlerOptions {
    // whether show detail error message
    showDetail?: boolean;

    // å¿½ç¥çéè¯¯ç ï¼å¦æ response çéè¯¯ç å¹éï¼ä¸å¼¹åºéè¯¯ä¿¡æ¯æç¤º
    ignoreErrorCodes?: number[];
}

@Injectable()
export class UtilService {
    constructor(
        public dialog: ThyDialog,
        public notify: ThyNotifyService,
        public pbox: ThyPopBoxService,
        public translate: TranslateService,
        public http: HttpClient
    ) {}

    private _getDefaultErrorMessage(response: any, source?: string) {
        if (response.method === 'GET') {
            return this.translate.instant('common.tips.NEXT_GET_DATA_FAILED', {
                source: source || ''
            });
        } else {
            const methodActionMap = {
                POST: 'common.ADD',
                PUT: 'common.MODIFY',
                DELETE: 'common.DELETE'
            };
            const actionTranslateKey = methodActionMap[response.method]
                ? methodActionMap[response.method]
                : 'common.OPERATION';

            const responseCode = response.code ? response.code : response.body.code;
            let translateKey = '';
            if ([1005, status.forbidden].includes(responseCode)) {
                translateKey = 'common.tips.NEXT_NO_PERMISSION';
            } else if (responseCode === 50015) {
                translateKey = 'common.tips.NAME_EXIST';
            } else {
                translateKey = 'common.tips.NEXT_OPERATE_DATA_FAILED';
            }
            return this.translate.instant(translateKey, {
                action: this.translate.instant(actionTranslateKey)
            });
        }
    }

    private _defaultErrorHandler(message?: string, options?: ErrorHandlerOptions) {
        options = Object.assign({ showDetail: true }, options);
        return response => {
            let showMessage = '';
            let detailErrorMessage = '';
            let responseCode: number;
            if (response.name === 'NotOKHttpResponseError') {
                // response.body.url = response.url;
                // errorMessage = JSON.stringify(response.body);
                detailErrorMessage = `Http failure response for ${response.url}, code is ${response.code},
              message is ${response.body.error_message || response.body.message || response.message}`;
                if (response.body.oid) {
                    detailErrorMessage = detailErrorMessage + `, oid is ${response.body.oid}`;
                }
                responseCode = response.code || response.body.code;
            } else {
                if (response.status !== status.ok) {
                    detailErrorMessage = response.message;
                } else if (response.body) {
                    response.body.url = response.url;
                    detailErrorMessage = JSON.stringify(response.body);
                }
            }

            if (!message) {
                showMessage = this._getDefaultErrorMessage(response);
            } else {
                showMessage = message;
            }
            const stopNotify =
                responseCode && options.ignoreErrorCodes && options.ignoreErrorCodes.includes(responseCode);
            if (!stopNotify) {
                this.notify.error(null, showMessage, options.showDetail ? detailErrorMessage : '');
            }
        };
    }

    defaultErrorHandler(message?: string, options?: ErrorHandlerOptions) {
        return this._defaultErrorHandler(message, options);
    }

    defaultErrorHandlerByTranslateKey(messageTranslateKey: string, options?: ErrorHandlerOptions) {
        const message = this.translate.instant(messageTranslateKey);
        this.defaultErrorHandler(message, options);
    }

    // // è¡¨åéè¯¯å¤ç
    // defaultFormErrorHandler(form?: ThyFormDirective, message?: string) {
    //     return this._defaultErrorHandler(message, null, form);
    // }

    // defaultFormErrorHandlerTranslateKey(form?: ThyFormDirective, messageTranslateKey?: string) {
    //     const message = this.translate.instant(messageTranslateKey);
    //     this._defaultErrorHandler(message, null, form);
    // }

    // ä¸æ¾ç¤º Detail ä¿¡æ¯
    pureErrorHandler(message?: string) {
        return this.defaultErrorHandler(message, {
            showDetail: false
        });
    }

    // ä¸æ¾ç¤º Detail ä¿¡æ¯
    pureErrorHandlerByTranslateKey(messageTranslateKey: string) {
        const message = this.translate.instant(messageTranslateKey);
        return this.pureErrorHandler(message);
    }

    public instantByObject(object: any) {
        for (const key in object) {
            if (object.hasOwnProperty(key)) {
                if (isString(object[key])) {
                    object[key] = this.translate.instant(object[key] as string);
                } else {
                    this.instantByObject(object[key]);
                }
            }
        }
        return object;
    }
}
